import moment from 'moment';
import Vue from 'vue';

const formatDate = (value, format) => {
  return moment(value).format(format);
};

Vue.filter('formatDate', (value) => {
  if (value) {
    return formatDate(value, 'DD/MM/YYYY');
  }
  return '';
});

Vue.filter('formatDateTime', (value) => {
  if (value) {
    return formatDate(value, 'DD/MM/YYYY HH:mm');
  }
  return '';
});
